var _path, _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoOtp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3026 19.5027L22.4292 18.6294L16.6765 24.3821V25.2555H17.5498L23.3026 19.5027ZM24.1759 18.6294L25.0493 17.756L24.1759 16.8827L23.3026 17.756L24.1759 18.6294ZM18.0612 26.4908H15.4412V23.8701L23.7393 15.572C23.8551 15.4562 24.0121 15.3912 24.1759 15.3912C24.3397 15.3912 24.4968 15.4562 24.6126 15.572L26.3599 17.3193C26.4757 17.4352 26.5408 17.5922 26.5408 17.756C26.5408 17.9198 26.4757 18.0769 26.3599 18.1927L18.0612 26.4908Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#paint0_linear_60_7304)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "url(#paint1_linear_60_7304)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_7304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.971 15.3254C18.2847 15.3254 16.107 17.5031 16.107 20.1893C16.107 22.8756 18.2847 25.0533 20.971 25.0533C23.6573 25.0533 25.8349 22.8756 25.8349 20.1893C25.8349 17.5031 23.6573 15.3254 20.971 15.3254ZM23.233 18.265C23.5497 18.5816 23.5497 19.0949 23.233 19.4114L20.5309 22.1137C20.3789 22.2657 20.1726 22.3511 19.9576 22.3511C19.7427 22.3511 19.5364 22.2657 19.3844 22.1137L18.3711 21.1004C18.0545 20.7837 18.0545 20.2705 18.3711 19.9539C18.6877 19.6373 19.201 19.6373 19.5175 19.9539L19.9576 20.394L22.0866 18.265C22.4032 17.9484 22.9165 17.9484 23.233 18.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2965 8.02942C13.9533 8.02942 12.8645 9.11826 12.8645 10.4614V31.5386C12.8645 32.8818 13.9533 33.9706 15.2965 33.9706H26.6458C27.9889 33.9706 29.0777 32.8818 29.0777 31.5386V10.4614C29.0777 9.11826 27.9889 8.02942 26.6458 8.02942H15.2965ZM14.4858 10.4614C14.4858 10.0137 14.8488 9.65074 15.2965 9.65074H15.6733L16.5726 10.9998C17.0237 11.6763 17.783 12.0827 18.5962 12.0827H23.346C24.1592 12.0827 24.9186 11.6763 25.3696 10.9998L26.269 9.65074H26.6458C27.0935 9.65074 27.4564 10.0137 27.4564 10.4614V28.296H14.4858V10.4614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_7304",
    x1: 20.2799,
    y1: 41.9993,
    x2: 20.2799,
    y2: -0.20532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8856"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_7304",
    x1: 20.2799,
    y1: 41.9993,
    x2: 20.2799,
    y2: -8.43876e-9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB4B03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F16722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776219,
    stopColor: "#FB8856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC4AA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_7304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9412,
    height: 25.9412,
    fill: "white",
    transform: "translate(8 8.02942)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOtp);
export default __webpack_public_path__ + "static/media/ico-otp.867af669560ee7470caf0d665a659097.svg";
export { ForwardRef as ReactComponent };